// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3oSYl","colMaxWidth":"Table_colMaxWidth__1wBhF"};